import {Injectable} from "@angular/core";
import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";
import {
  ChatDto,
  ChatMemberType,
  ChatMessageListDto,
  ContactChatMemberDto,
  ContactListDto,
  FilterDto, FilterOperators, FilterTypes,
  LocationChatMemberDto,
  LocationListDto, Orders,
} from '@server-models';
import {Observable} from "rxjs";
import {ILocalPageOutputDto} from "@shared/interfaces/orga-response.interface";
import {CoreErrorHandlerBaseService} from "@core/services/error-handler-base/core-error-handler-base.service";

@Injectable({
  providedIn: 'root',
})
export class SharedChatApiService extends CoreHttpClientApiBaseService {

  addMessage(chatId: any, message: ChatMessageListDto): Observable<ChatMessageListDto> {
    return super.post<ChatMessageListDto>(`/orga/chat/${ chatId }/addMessage`, undefined, message);
  }

  getChatById(chatId: number): Observable<ChatDto> {
    return super.get<ChatDto>(`/orga/chat/${ chatId }`, undefined, { errorHandler: {} as CoreErrorHandlerBaseService });
  }

  pollChatMessages(
    chatId: number,
    lastMessageId: number = 0,
    sortOrder: Orders = Orders.Ascending
  ): Observable<ILocalPageOutputDto<ChatMessageListDto[]>> {
    const filters = [{
      type: FilterTypes.DataTransferObject,
      property: "chatMessageId",
      operator: FilterOperators.GreaterThan,
      value: lastMessageId.toString()
    }];

    const options = {
      params: {
        pageNumber: 1,
        pageSize: 250,
        sortField: 'chatMessageId',
        sort: sortOrder
      },
      errorHandler: {} as CoreErrorHandlerBaseService
    };

    return super.post<ILocalPageOutputDto<ChatMessageListDto[]>>(
      `/orga/chat/${ chatId }/message/filter`,
      undefined,
      filters,
      options
    );
  }

  addChatMember(
    chatId: number,
    member: LocationListDto | ContactListDto
  ): Observable<LocationChatMemberDto | ContactChatMemberDto> {
    return super.post<LocationChatMemberDto | ContactChatMemberDto>(`/orga/chat/${ chatId }/addMember`, undefined, member);
  }

  removeChatMember(
    chatId: number,
    member: LocationListDto | ContactListDto
  ): Observable<void> {
    return super.post<void>(`/orga/chat/${ chatId }/removeMember`, undefined, member);
  }

  addMe(
    chatId: number
  ): Observable<LocationChatMemberDto | ContactChatMemberDto> {
    return super.post<LocationChatMemberDto | ContactChatMemberDto>(`/orga/chat/${ chatId }/addMember/me`, undefined);
  }

  removeMe(
    chatId: number
  ): Observable<void> {
    return super.post<void>(`/orga/chat/${ chatId }/removeMember/me`, undefined);
  }

  deleteChatMessage(chatId: number, chatMessageId: number): Observable<void> {
    return super.post(`/orga/chat/${ chatId }/message/${ chatMessageId }/deleteMessage`);
  }
}
